import { Injectable }       from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }     from '../../api/api.service';
import { ConfirmService } from '../confirm/confirm.service';

@Injectable()
export class CustomerMessagesService {
  title = this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.CUSTOMER_MESSAGES.CUSTOMER_MESSAGES');

  constructor(
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private translateService: TranslateService,
  ) {}

  activateLookups () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
      name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.CUSTOMER_MESSAGES.CUSTOMER_MESSAGES')
    }))
    .then(() => this.apiService.get('/sms_global_account/activate_sms_global_account'));
  }

  deactivateLookups () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.REMOVE_INTEGRATION', {
      name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.CUSTOMER_MESSAGES.CUSTOMER_MESSAGES')
    }))
    .then(() => this.apiService.get('/sms_global_account/disable_sms_global_account'));
  }

  getLatestMessagesLogs ( params : any ) : Promise<any> {
    return this.apiService.get('/sms_logs/get_recent_sms_log_customers', [ params.page_size, params.offset ]);
  }

  getCustomerSmsLogs ( customerId : any, params : any ) : Promise<any> {
    return this.apiService.get('/sms_logs/get_customer_sms_logs', [ customerId, params.page_size, params.offset ]);
  }

  search ( query : string ) : ng.IPromise<Array<any>> {
    return this.apiService.stream('/searches', [ query, 'customers' ]);
  }

}